var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnSiteVisit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 43,
    viewBox: "0 0 33 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10131 22.7926L3.1014 22.7927L3.10131 22.7926ZM10.2126 40.8943L10.2128 40.8944C12.0763 41.6291 14.0662 42.0044 16.0736 42.0002C18.0793 42.0033 20.0673 41.6281 21.9293 40.8945L21.9297 40.8943C23.7002 40.1959 25.3204 39.1735 26.7035 37.8806C28.0738 36.6092 29.1762 35.0844 29.9465 33.3928L29.9474 33.3909C30.7321 31.6583 31.1378 29.7827 31.1378 27.8855C31.1378 25.9883 30.7321 24.1128 29.9474 22.3801L29.9465 22.3782C29.1762 20.6866 28.0738 19.1617 26.7034 17.8903C25.3203 16.5975 23.7002 15.5751 21.9297 14.8767V14.8767L21.9274 14.8758C18.1659 13.4027 13.9719 13.4027 10.2105 14.8758L10.2082 14.8767C8.43762 15.5752 6.81747 16.5976 5.43436 17.8904C4.06402 19.1618 2.96167 20.6866 2.19132 22.3782L2.19047 22.3801C1.40577 24.1128 1 25.9883 1 27.8855C1 29.7827 1.40577 31.6583 2.19046 33.3909L2.19158 33.3934C2.96329 35.0853 4.0672 36.61 5.43913 37.8809C6.82217 39.1736 8.44221 40.1959 10.2126 40.8943Z",
    fill: "white",
    stroke: "#717070",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.225 22.0381L21.3576 10.8625C21.3576 10.8625 17.7301 1.0659 26.225 1.00032C34.7198 0.93475 31.3307 10.8625 31.3307 10.8625L26.225 22.0381Z",
    fill: "#717070",
    stroke: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2481 10.3601C28.2922 10.3601 29.9492 8.78842 29.9492 6.84971C29.9492 4.91099 28.2922 3.33936 26.2481 3.33936C24.204 3.33936 22.5469 4.91099 22.5469 6.84971C22.5469 8.78842 24.204 10.3601 26.2481 10.3601Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2477 10.1412C28.1687 10.1412 29.726 8.66739 29.726 6.84939C29.726 5.03139 28.1687 3.55762 26.2477 3.55762C24.3268 3.55762 22.7695 5.03139 22.7695 6.84939C22.7695 8.66739 24.3268 10.1412 26.2477 10.1412Z",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 12.7711,
    y2: -1,
    transform: "matrix(-0.77254 0.634966 -0.666438 -0.745561 16.1602 17.8306)",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 12.9583,
    y2: -1,
    transform: "matrix(-0.776641 -0.629944 0.661524 -0.749924 27 26.623)",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.56055,
    y1: 24.6597,
    x2: 9.56055,
    y2: 35.7759,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7188,
    y1: 24.6597,
    x2: 22.7188,
    y2: 35.7759,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 35V31H16.5V35H15.5Z",
    stroke: "#717070",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSiteVisit);
export default __webpack_public_path__ + "static/media/on-site-visit.bbef3b2f24ad44ebe6384c6afe704ed5.svg";
export { ForwardRef as ReactComponent };